import { render } from "./m-card-result.vue?vue&type=template&id=0d607c52&scoped=true&ts=true"
import script from "./m-card-result.vue?vue&type=script&lang=ts"
export * from "./m-card-result.vue?vue&type=script&lang=ts"

import "./m-card-result.vue?vue&type=style&index=0&id=0d607c52&lang=scss&scoped=true"

import exportComponent from "D:\\project\\newD\\floor30-ws-with-server-selection\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d607c52"]])

export default __exports__